import React, {useEffect, useState} from "react";
import styled from "styled-components";
import Menu from "../components/header/Menu";
import {flexCreator} from "../hooks/helpers";
import {ReactComponent as UserIcon} from "../assets/icons/user.svg";
import {ReactComponent as BackIcon} from "../assets/icons/arrow2.svg";
import {useHistory, useLocation, useParams} from "react-router-dom";
import MyProfileModal from "../components/modals/MyProfileModal";

const selectBackColor = (type) => {
   type = Number(type);
   switch (type) {
      case 1:
         return "#af0069";
      case 2:
         return "#8e44ad";
      case 3:
         return "#2980b9";
      case 5:
         return "#8e44ad";
      default:
         return "#32529d";
   }
};
const selectTitle = (type) => {
   type = Number(type);
   switch (type) {
      case 1:
         return "Curso esencial";
      case 2:
         return "Cursos Prime";
      case 3:
         return "Certificado Emblem";
      case 5:
         return "Masterclass";
      default:
         return "#32529d";
   }
};

export default function MainContainer({children, title, theme}) {
   const [currentTeme, setTheme] = useState({});
   const [currentTitle, setCurrentTitle] = useState("");
   const [second, setSecond] = useState(false); // si es pantalla secundaria mostar  back icon
   const [modalProfile, setModalProfile] = useState(false);
   let location = useLocation();
   let history = useHistory();
   let {id, type} = useParams();

   useEffect(() => {
      let splitLocation = location.pathname.split("/");
      let hasUser = location.pathname.indexOf("user") > -1;

      if (splitLocation.length > 2 && !hasUser) {
         setSecond(true);
      }
      return () => {
         setSecond(false);
      };
   }, [location]);

   useEffect(() => {
      setTheme(theme);
   }, [theme]);

   useEffect(() => {
      if (second) {
         if (type) {
            setTheme({...theme, back: selectBackColor(type)});
            setCurrentTitle(selectTitle(type));
         }
      }
   }, [second]);

   const toBack = () => {
      let prev = location.state ? location.state.prev : null;

      if (prev) {
         return history.replace(prev);
      }
      history.goBack();
   };

   return (
      <MainContent>
         <Aside>
            {/* Menu */}
            <Menu />
         </Aside>
         <Main>
            {/* Header de la vista */}
            <Header back={currentTeme.back}>
               {second && (
                  <div className="backIcon">
                     <button onClick={toBack}>
                        <BackIcon width="2.5em" height="2.5em" className="icon" />
                     </button>
                  </div>
               )}

               <div className="titleContainer">
                  <p className="titleHead">{currentTitle || title}</p>
               </div>

               <div className="iconContainer">
                  <button
                     onClick={() => {
                        setModalProfile(true);
                     }}
                  >
                     <UserIcon width="3em" height="3em" className="icon" />
                  </button>
               </div>
            </Header>
            <Content>
               {/* {Contenido} */}
               {children}
            </Content>
         </Main>
         <MyProfileModal 
            isOpen={modalProfile}
            close={() => {
               setModalProfile(false);
            }}
            theme={currentTeme}
         />
      </MainContent>
   );
}

MainContainer.defaultProps = {
   title: "título de vista",
};

const MainContent = styled.div`
   height: 100vh;
   // display: flex;
   // overflow-y: scroll;
`;

const Aside = styled.aside`
   width: 10%;
   height: 100vh;
   float: left;
   border-right: 1px solid #1c355e;
   box-sizing: border-box;
   position: -webkit-sticky;
   position: sticky;
   top: -2em;
`;
const Main = styled.main`
   height: 100%;
   width: 90%;
   padding: 0;
   background: #f5f5f5;
   float: left;
   overflow-y: scroll;
   paddin-bottom: 2em;

   display: grid;
   grid-template-columns: repeat(2, 1fr);
   grid-template-rows: repeat(15, 1fr);
`;
const Header = styled.header`
   background: ${(props) => props.back};
   grid-area: 1 / 1 / span 2 / span 3;

   display: grid;
   grid-template-columns: repeat(24, 1fr);
   grid-template-rows: 100%;
   padding: 0 1.5em;
   transition: all 420ms;

   .titleContainer {
      grid-area: 1 / 1 / 2 / -1;

      .titleHead {
         color: white;
         font-size: 1.8em;
         text-transform: capitalize;
         text-align: center;
      }
   }

   .iconContainer {
      grid-area: 1 / -1 / 2 / -3;

      button {
         width: 100%;
         height: 100%;
         background: transparent;
         ${flexCreator("end", "center")};
         cursor: pointer;

         &:active {
            & .icon {
               transform: scale(0.7);
               transition: transform 420ms ease;
            }
         }
      }
   }
   .backIcon {
      grid-area: 1 / 1 / 2 / 2;

      button {
         width: 100%;
         height: 100%;
         background: transparent;
         ${flexCreator("end", "center")};
         cursor: pointer;

         &:active {
            & .icon {
               transform: scale(0.7);
               transition: transform 420ms ease;
            }
         }
      }
   }
`;

const Content = styled.section`
   background-color: #f5f5f5;
   grid-area: 3 / 1 / span 15 / span 2;
   box-sizing: border-box;
   padding: 1.5em;
   padding-bottom: 5em;
`;
